import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TheMostAmazingConnectImage from '../assets/the-most-amazing-way-to-connect.svg';

import * as Api from '../services/api';
import Box from '../components/Box';
import Container from '../components/Container';
import Row from '../components/Row';
import { useAppContext } from '../context/AppContext';
import FullWidthLayout from '../layouts/FullWidthLayout';
import AppButtons from '../components/Common/AppButtons';
import useSessionStorage from '../hooks/useSessionStorage';

import Typography from '@mui/joy/Typography';
import { createTracker } from '../utils/log';

const PurchaseConfirmationPage = () => {
  const { andee, sessionInfo } = useAppContext();
  const [sessionCart, setSessionCart] = useSessionStorage();
  const { cart: localCart, setCart: setLocalCart } = useAppContext();
  const navigate = useNavigate();
  const [claimedCopy, setClaimedCopy] = useState('Congrats! Your purchase is confirmed.');
  const trackEvent = createTracker(andee, sessionInfo);

  useEffect(() => {
    trackEvent('page_view', { page_name: 'purchase_confirmation' });
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    const cart = sessionCart.tags?.length > 0 ? sessionCart : localCart;
    const setCart = sessionCart.tags?.length > 0 ? setSessionCart : setLocalCart;

    if (query.get('success')) {
      trackEvent('purchase', { status: 'success' });
      Api.purchaseTags(andee, cart.tags)
        .then(async (res) => {
          await Api.sendEmailConfirmation(cart);
          trackEvent('purchase', { status: 'email_confirmation_sent' });
        })
        .catch((err) => {
          trackEvent('purchase', { status: 'failed', error: err });
          console.error(err);
        })
        .finally(() => Api.resetCart(setCart));
    } else if (query.get('canceled')) {
      trackEvent('purchase', { status: 'canceled' });
      navigate('/marketplace');
    } else if (query.get('claimed')) {
      trackEvent('purchase', { status: 'claimed', comment: 'free &tag(s)' });
      const claimedTags = query.get('tags');
      if (claimedTags) {
        const tagArray = claimedTags.split(',');
        const copy = `${tagArray.map((tag) => `&${tag}`).join(', ')} ${tagArray.length === 1 ? 'has' : 'have'} been claimed.`;
        setClaimedCopy(copy);
      }
    } else {
      // go back to the previous page, wherever that was
      navigate(-1);
    }
  }, []);

  return (
    <FullWidthLayout showTryApp={false}>
      <Container>
        <Row flexDirection="column" alignItems="center">
          <Box style={styles.box}>
            <img style={{ paddingBottom: 30 }} src={TheMostAmazingConnectImage} alt="The most amazing way to connect" />
            <Typography level="h2">Secure Your <b>&tags</b></Typography>
            <Typography sx={{}}>{claimedCopy}
            </Typography>
            <Typography sx={{ pt: 2, pb: 5 }}>Next, create your <span className="and-logo">&</span> identity in the app to fully secure <br />+ start using your <b>&tags.</b>
            </Typography>
            <AppButtons />
            <Typography level="body2" sx={{ pt: 2, fontStyle: 'italic' }}>Get the app. Without it, you'll lose access to your purchases if your email or phone ever changes.</Typography>
          </Box>
        </Row>
      </Container>
    </FullWidthLayout>
  );
};

const styles = {
  title: {
    fontWeight: 500,
    textAlign: 'center',
    color: '#BABABA'
  },
  boxTitle: {
    color: '#545454',
  },
  box: {
    textAlign: 'center',
    background: '#FFFFFF',
    boxShadow: '0px 4px 114px rgba(0, 0, 0, 0.2)',
    borderRadius: 10,
    maxWidth: 900,
  }
};

export default PurchaseConfirmationPage;
